import React from 'react';

const Clients = () => (
  <React.Fragment>
    {/* <div className="container py-3">
      <div className="row">
        <div className="col-10 mx-auto">
          <div id="logoCarousel" className="carousel slide pt-2" data-ride="carousel" data-interval="3300">
            <div className="carousel-inner" role="listbox">
              <div className="carousel-item active">
                <div className="row text-center">
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-1.png" className="img-fluid mx-auto" alt="Mashable" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-2.png" className="img-fluid mx-auto" alt="TechCrunch" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-3.png" className="img-fluid mx-auto" alt="TechRadar" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-4.png" className="img-fluid mx-auto" alt="BBC" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-5.png" className="img-fluid mx-auto" alt="Reddit" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="row text-center">
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-1.png" className="img-fluid mx-auto" alt="Mashable" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-2.png" className="img-fluid mx-auto" alt="TechCrunch" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-3.png" className="img-fluid mx-auto" alt="TechRadar" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-4.png" className="img-fluid mx-auto" alt="BBC" />
                    </a>
                  </div>
                  <div className="col">
                    <a href="">
                      <img src="/assets/images/logos/press-5.png" className="img-fluid mx-auto" alt="Reddit" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
  </React.Fragment>
);
export default Clients;



// WEBPACK FOOTER //
// ./src/components/Clients.js